// src/components/Tabs.jsx
export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <div className="bg-red-800 border-b">
      <div className="flex">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              flex-1 py-3 text-sm font-medium bg-purple-700
              ${activeTab === tab.id
                ? 'text-yellow-200 border-b-2 border-pink-600'
                : 'text-white hover:text-gray-100'}
            `}
          >
            {tab.emoji}{tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}